<div class="schedule-tour-holder p-4">
    <div class="schedule-tou-container data-table-container p-4">

        <ng-container *ngIf="showForm; else messageTpl">
            <div class="content-wrapper" [class.content-visible]="showContent">
                <div class="page-title">
                    <h3>Schedule Tour</h3>
                    <p>Please enter your details to unlock available time slots.</p>
                </div>
                <form [formGroup]="scheduleForm" (ngSubmit)="goToNextStep()">
                    <div class="row">
                        <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                                <label>Visitor Name</label>
                                <input pInputText formControlName="visitorName" placeholder="Enter your name" required />
                                <div *ngIf="scheduleForm.controls['visitorName'].invalid && scheduleForm.controls['visitorName'].touched"
                                    class="text-danger">
                                    Name is required
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                                <label>Visitor Email</label>
                                <input pInputText formControlName="visitorEmail" placeholder="Enter your email" type="email"
                                    required />
                                <div *ngIf="scheduleForm.controls['visitorEmail'].invalid && scheduleForm.controls['visitorEmail'].touched"
                                    class="text-danger">
                                    Enter a valid email
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                                <label>Visitor Phone</label>
                                <input type="text" pInputText formControlName="visitorPhone" placeholder="Enter phone"
                                    placeholder="xxx-xxx-xxxx" mask="000-000-0000" [validation]="true" />
                                <!-- <div *ngIf="scheduleForm.controls['visitorPhone'].invalid && scheduleForm.controls['visitorPhone'].touched" class="text-danger">
                                    Enter a valid US phone number
                                </div> -->
                                <div class="error text-danger"
                                    *ngIf="scheduleForm.controls['visitorPhone'].invalid && scheduleForm.controls['visitorPhone'].touched">
                                    <small class="text-danger"
                                        *ngIf="scheduleForm.get('visitorPhone')?.errors?.['required']">Phone Number is
                                        required.</small>
                                    <small class="text-danger"
                                        *ngIf="scheduleForm.get('visitorPhone')?.errors?.['invalidUSPhone']">
                                        Kindly provide a valid US phone number in this formats:
                                        <code>000-000-0000</code>
                                        with a valid US area code.
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                            <div class="form-group">
                                <label>Unit</label>
                                <p-dropdown [options]="unitOptions" formControlName="planName" placeholder="Select Unit"
                                    [disabled]="isModelUnit"
                                    required>
                                </p-dropdown>
                                <div class="error text-danger"
                                    *ngIf="scheduleForm.get('planName')?.invalid && scheduleForm.get('planName')?.touched">
                                    <small class="text-danger" *ngIf="scheduleForm.get('planName')?.errors?.['required']">
                                        Please select a unit.
                                    </small>
                                </div>
                                <small class="text-muted" *ngIf="isModelUnit">
                                    This property schedules tours as Model Unit only.
                                </small>
                            </div>
                        </div>
                        <div class="col-12 mt-3" *ngIf="step === 1">
                            <div class="d-flex justify-content-end">
                                <p-button type="submit" class="primary-btn" label="Continue to Schedule"
                                    [disabled]="scheduleForm.invalid">
                                </p-button>
                            </div>
                        </div>
                    </div>
                </form>
                <div [ngClass]="step === 2 ? '' : 'schedule-tour-diabled' ">
                    <div class="row mt-5">
                        <div class="col-lg-6 col-12">
                            <h5>Select Date</h5>
                            <p-calendar [(ngModel)]="selectedDate" [inline]="true" [showIcon]="false" [touchUI]="false"
                                [minDate]="minDate" [maxDate]="maxDate" [style]="{ width: '100%' }" class="text-center"
                                (onSelect)="goToTimeSelection()">
                            </p-calendar>
                        </div>
                        <div class="col-lg-6 col-12">
                            <h5>Select Time Slot</h5>
                            <div *ngIf="!selectedDate" class="alert alert-warning">
                                Please select a date first.
                            </div>
                            <div [ngClass]="selectedDate ? '' : 'schedule-tour-diabled' " class="time-slot-grid">
                                <button *ngFor="let time of availableTimes" pButton [label]="time"
                                    [class.p-button-outlined]="selectedTime !== time"
                                    [class.p-button-primary]="selectedTime === time" (click)="selectedTime = time">
                                </button>

                                <div *ngIf="availableTimes.length === 0"
                                    class="text-danger h-100 d-flex align-items-center justify-content-center">
                                    No available slots for the selected date.
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="d-flex justify-content-end gap-2 mt-3">
                                <p-button label="Cancel" class="secondary-btn" (click)="closeDialogue()"></p-button>
                                <p-button label="Schedule Tour" class="primary-btn"
                                    [disabled]="!selectedDate || !selectedTime || isConfirmLoading" [loading]="isConfirmLoading"
                                    (click)="scheduleTour()">
                                </p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #messageTpl>
            <ng-container *ngIf="showMessage">
                <div class="content-wrapper" [class.content-visible]="showContent">
                    <div class="row mt-5">
                        <div class="col-12">
                            <div class="thank-you-message text-center p-5 page-title">
                                <h3 [innerHTML]="message"></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-template>
    </div>
</div>

<p-toast></p-toast>
